import React, { useEffect, useState } from 'react'
import { Table } from '../../../../components/ui'
import { useParams } from 'react-router-dom';
import { GetImageReport } from '../../../../apis/events';
import { Image } from 'antd';

export default function EventImageReports() {
  const {id} = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try{
        const res = await GetImageReport({id});
        if(res.status === 200 && res.data.success){
          setData(res.data.report_list);
        }
      }catch(error){
        console.log(error);
      } finally {
        setLoading(false);
      }
    })()

  }, []); // eslint-disable-line

  const columns = [
    {
      title: "Image",
      key: "image_id",
      render: (text, record) => (
        <Image width={40} height={40} src={record.image_detail.image_url} fallback='https://via.placeholder.com/150' />
      )
    },
    {
      title: 'Issue Description',
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: 'Reported By',
      key: 'reported_by',
      render: (text, record) => (
        <span>{record.user_detail.mobile_number}</span>
      )
    }
  ]


  return (
    <div>
      <Table
        columns={columns}
        data={data}
        loading={loading}
      />

    </div>
  )
}
